"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reset = reset;
exports.identify = identify;
exports.group = group;
exports.track = track;
exports.trackLink = trackLink;
exports.upgradeLinkClicked = upgradeLinkClicked;
exports.pageView = pageView;
exports.init = init;
const segment_1 = require("./segment");
const businessapp_browserstorage_1 = require("@trustpilot/businessapp-browserstorage");
const utils_1 = require("./utils");
let businessUser;
let businessUnit;
let defaultEventData;
function reset() {
    window.analytics.reset();
}
function identify(emailAddress, traits, options) {
    const { email, id, name, activationDate, country } = businessUser;
    const enrichedEmail = emailAddress || email || "";
    const enhancedData = {
        id,
        name,
        email: enrichedEmail,
        created: new Date(activationDate || "").toISOString(),
        country: country?.country,
        locale: defaultEventData.locale,
        ...traits,
    };
    return new Promise((resolve) => {
        window.analytics.identify((0, utils_1.hashEmailForId)(enrichedEmail), enhancedData, (0, utils_1.getOptions)(options, enrichedEmail), () => resolve());
    });
}
function group(traits, options) {
    if (!businessUnit) {
        return Promise.resolve();
    }
    const enhancedData = { ...defaultEventData, ...traits };
    return new Promise((resolve) => {
        window.analytics.group(`buid-${businessUnit?.id}`, enhancedData, (0, utils_1.getOptions)(options), () => resolve());
    });
}
/**
 * Attaches business unit data to the event and tracks it
 */
function track(eventName, eventData) {
    const enhancedData = { ...defaultEventData, ...eventData };
    return new Promise((resolve) => {
        window.analytics.track(eventName, enhancedData, (0, utils_1.getOptions)(), () => resolve());
    });
}
/**
 * Attaches a track callback that provides a delay between page changes
 */
function trackLink(domElement, eventName, eventData) {
    const enhancedData = { ...defaultEventData, ...eventData };
    window.analytics.trackLink(domElement, eventName, enhancedData);
}
function upgradeLinkClicked(source) {
    return track("UpgradeLinkClick", {
        UpgradeSource: source,
    });
}
function pageView(name, eventData) {
    const enhancedData = {
        ...defaultEventData,
        ...eventData,
    };
    return new Promise((resolve) => {
        window.analytics.page(name, enhancedData, (0, utils_1.getOptions)(), () => resolve());
    });
}
async function init(_businessUser, _businessUnit, locale, configuration) {
    businessUser = _businessUser;
    businessUnit = _businessUnit;
    defaultEventData = {
        locale,
        ...((businessUnit && {
            domain: businessUnit.name?.identifying || "",
            tierName: businessUnit.tier?.name || "",
            businessUnitId: businessUnit.id || "",
            modules: businessUnit.businessModules || [],
            isPaying: businessUnit.isPaying || false,
            userRole: businessUnit.access?.role?.name || "",
        }) ||
            {}),
    };
    // Analytics is already initialized.
    const hasAlreadyInit = Boolean(document.querySelector('script[data-script-id="analytics"]'));
    if (!configuration || hasAlreadyInit) {
        return false;
    }
    const analytics = (0, segment_1.initializeAnalyticsJS)();
    await businessapp_browserstorage_1.CookieConsent.onceConsentGiven(businessapp_browserstorage_1.COOKIE_GROUPS.PERFORMANCE, async () => {
        const { segmentIoKey, integrations } = configuration;
        const hasMarketingConsent = await businessapp_browserstorage_1.CookieConsent.hasCategoryConsent(businessapp_browserstorage_1.COOKIE_GROUPS.MARKETING);
        const integrationsObject = [
            ...integrations.nonMarketing,
            ...(hasMarketingConsent ? integrations.marketing : []),
        ].reduce((acc, cur) => ({
            ...acc,
            [cur]: true,
        }), { All: false });
        analytics.load(segmentIoKey, {
            integrations: integrationsObject,
        });
    });
    await businessapp_browserstorage_1.CookieConsent.onConsentChange(async ({ detail }) => {
        // If the user has removed consent for performance cookies, we need to reset Segment
        if (!detail.includes(businessapp_browserstorage_1.COOKIE_GROUPS.PERFORMANCE)) {
            analytics.reset();
        }
        businessapp_browserstorage_1.CookieConsent.removeAllBrowserData();
        // Reload browser to make sure that integrations are added or removed
        // according to the new consent
        window.location.reload();
    });
}
//# sourceMappingURL=analytics.js.map